import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getCleanPath } from 'js/utils/url.util';

/**
 * Event fires when player navigates to another page.
 * @memberOf Playtech.API.events
 * @event navigate
 * @type {callback}
 * @param {Object} details
 * @param {string} details.pathname Path of a page.
 * @param {string} details.cleanPathname Path of a page without language code.
 * @param {string} details.prevPathname Path of a previous page.
 * @param {string} details.cleanPrevPathname Path of a previous page without language code.
 * @example Playtech.on('navigate', ({ pathname, cleanPathname, prevPathname, cleanPrevPathname }) => { ... });
 */
export const EVENT_ON_NAVIGATE = 'navigate';

export const useOnNavigate = (eventTarget) => {
    const prevPathnameRef = useRef('');
    const { pathname } = useLocation();

    useEffect(() => {
        const event = new CustomEvent(EVENT_ON_NAVIGATE, {
            detail: {
                pathname,
                cleanPathname: getCleanPath(pathname),
                prevPathname: prevPathnameRef.current,
                cleanPrevPathname: getCleanPath(prevPathnameRef.current)
            }
        });

        eventTarget.dispatchEvent(event);

        prevPathnameRef.current = pathname;
    }, [pathname, eventTarget]);
};
